module.exports = __webpack_public_path__ + "static/media/filip-trbojevic.220b04ad.jpg";